
import '../static/iconfonts/style.css'

import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/index'
import utils from "./utils/utils"
import common from "./utils/common"
import myFilters from './utils/filters'
import MTA from './utils/MTA'
import helpMask from './components/uimask/index'

import gallery from 'img-vuer'

Vue.use(MTA)
Vue.use(common)
Vue.use(helpMask)

Vue.use(gallery, {
    swiperThreshold: 30
})

// 引入粘贴板插件
import VueClipboards from 'vue-clipboards';
Vue.use(VueClipboards);

import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
Vue.use(preview, {
    tapToClose: true,
    spacing: 0.05,
    maxSpreadZoom: 3,
    fullscreenEl: false,
    zoomEl: true
})






// import resultList from './components/resultList.vue'
// Vue.component(resultList.name, resultList)
import resultList2 from './components/resultList2.vue'
Vue.component(resultList2.name, resultList2)
// import resultDetail from './components/resultDetail.vue'
// Vue.component(resultDetail.name, resultDetail)
import VueTouch from 'vue-touch'
Vue.use(VueTouch, {name: 'v-touch'})
VueTouch.config.swipe = {
    threshold: 50 //手指左右滑动距离

}

import Bounce from 'vue-bounce'
Vue.use(Bounce)

Vue.use(utils)
Object.keys(myFilters).forEach((key) => {
    Vue.filter(key, myFilters[key])
})
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    template: '<App/>',
    components: {App}
})




// WEBPACK FOOTER //
// ./src/main.js